import { render, staticRenderFns } from "./WorkingVisa.vue?vue&type=template&id=6913da53&"
import script from "./WorkingVisa.vue?vue&type=script&lang=js&"
export * from "./WorkingVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports